import { useNotificationsCenter } from '@contexts/NotificationsCenterContext';
import { NotificationListItemComponents } from './NotificationsCenterListItem/NotificationsCenterListItem';

function NotificationsCenterList() {
  const { notifications } = useNotificationsCenter();

  return (
    <div className="overflow-y-auto sy-scrollbar sy-scrollbar-light pb-2 space-y-1">
      {notifications.map((notification) => {
        const NotificationListItem = NotificationListItemComponents[notification.service];

        return <NotificationListItem key={notification.id} notification={notification} />;
      })}
    </div>
  );
}

export { NotificationsCenterList };
